import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const MAX = 200 * 1024;

export async function compressTo200KB(file) {
  const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file); });
  let scale = Math.min(1, 1600 / Math.max(img.width, img.height));
  for (let round = 0; round < 8; round++) {
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    let q = 0.85;
    while (q >= 0.3) {
      const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", q));
      if (blob.size <= MAX) return blob;
      q -= 0.1;
    }
    scale *= 0.75;
  }
  throw new Error("Foto tidak bisa dikompres ≤200KB");
}

export function PhotoUpload({ value = [], onChange, testid = "photo-upload" }) {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const f of files) {
      try {
        const blob = await compressTo200KB(f);
        const fd = new FormData();
        fd.append("file", blob, f.name.replace(/\.[^.]+$/, "") + ".jpg");
        const r = await api.post("/upload/photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
        added.push({ file_id: r.data.file_id, size: r.data.size, name: f.name, preview: URL.createObjectURL(blob) });
      } catch (err) { toast.error(`${f.name}: ${errMsg(err)}`); }
    }
    onChange([...value, ...added]);
    setBusy(false);
    e.target.value = "";
  };
  return (
    <div className="photo-upload" data-testid={testid}>
      <input type="file" accept="image/*" multiple capture="environment" onChange={pick} disabled={busy} data-testid={`${testid}-input`} />
      <small className="muted">{busy ? "Mengompres & mengunggah... / 压缩上传中" : "Boleh pilih beberapa foto; otomatis dikompres ≤200KB per foto / 可多选，自动压缩至200KB"}</small>
      <div className="photo-strip">
        {value.map((p, i) => <div className="photo-thumb" key={p.file_id}><img src={p.preview} alt="" /><small>{Math.round(p.size / 1024)} KB</small><button type="button" className="btn-mini danger" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}>✕</button></div>)}
      </div>
    </div>
  );
}

export function PhotoGallery({ ids = [], legacy }) {
  const [urls, setUrls] = useState([]);
  useEffect(() => {
    let alive = true;
    const out = [];
    Promise.all(ids.map((id) => api.get(`/files/${id}`, { responseType: "blob" }).then((r) => out.push(URL.createObjectURL(r.data))).catch(() => {}))).then(() => alive && setUrls([...out]));
    return () => { alive = false; out.forEach((u) => URL.revokeObjectURL(u)); };
  }, [ids]);
  if (!ids.length && !legacy) return null;
  return <div className="photo-strip" data-testid="photo-gallery">{legacy && <img src={legacy} alt="bukti" className="photo-preview" />}{urls.map((u, i) => <a key={i} href={u} target="_blank" rel="noreferrer"><img src={u} alt={`bukti ${i + 1}`} className="photo-preview" /></a>)}</div>;
}
